<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
<div class="label">{{action}} <span *ngIf="progress">{{progress}}%</span></div>
